export const projects = [
  {
    name: "FruitMania",
    description:
      "This is my first professional project as a software engineer working with a company to make it fully functional and responsive.This is an E-commerce suit with admin portal , mobile app ,delivery boy app and inventory management system",
    link: "https://fruitmania.co/",
    type: "Professional",
    tech: ["ReactJs", "Ruby On Rail", "SeamnticUI", "MySQL"]
  },
  {
    name: "The Golden Blogger",
    description:
      "A social media blogging app, where you can sign up and share your stories with the world .Like ,share and comment on your favourite stories and give them a follow . You can view users profile and discover new people  and read their stories . This application has two user roles , admin and a user , admin can add , edit or delete a user's profile and posts . A user has abilities to post blogs , comment , like , and share. .",
    link: "https://thegoldenblogger.netlify.app",
    type: "Personal",
    tech: ["ReactJs", "Express", "SeamnticUI", "MongoDB", "Node"]
  },
  {
    name: "HackerNews Clone",
    description:
      "This application is a clone of HackerNews, with a smoth UI/UX and with more additional features.This project uses the api’s provided by the HackerNews open source initiative.",
    link: "https://hackernewsbyahmer.netlify.app/",
    type: "Personal",
    tech: ["ReactJs", "Express", "SeamnticUI", "MongoDB", "Node"]
  },
  {
    name: "Mern Bootcamp - E-commerce",
    description:
      "An E commerce application which I made during my mern bootcamp course .The user will be able to order multiple products and see real time package information through profile page.This includes admin login and customer login.",
    link: "https://github.com/AhmerAftabPatel/mernbootcamp",
    type: "Personal",
    tech: ["ReactJs", "Express", "SeamnticUI", "MongoDB", "Node"]
  },
  {
    name: "Text-Based Game Using Unity Engine ",
    description:
      "A Text Based adventure game in which player explores a series of rooms by reading text and inputting commands.There are different types story modes based on user inputs and commands.",
    link: "https://drive.google.com/drive/folders/1XxODsza5P7JpQhGaeSDSKNwskquAP7Jl?usp=sharing",
    type: "Personal",
    tech: ["Unity", "C#"]
  },
  {
    name: "contactyyy",
    description:
      "A Project made for the use of people who likes to takes notes or maintain a diary , this app stores everything from contact informatioon of any person to any links with a simple click",
    link: "https://contactyy.netlify.app/",
    type: "Personal",
    tech: ["ReactJs", "TypeScript", "pure css", "MongoDB"]
  },
  {
    name: "ShopFront",
    description:
      "A shop front where you can show case your shop speciality and work , this website tells about their work and customers in a very unique way ",
    link: "https://github.com/AhmerAftabPatel/barber",
    type: "Personal",
    tech: ["Html", "JavaScript", "pure css"]
  },
  {
    name: "Developer vs Good Developer",
    description:
      "Nobody wants to continue a project with horrible or messy code. Sometimes developers avoid writing clean code due to deadline pressure. They rush to go faster but what happens actually is they end up with going slower...",
    link: "https://thegoldenblogger.medium.com/developer-vs-good-developer-ed741bcd923c",
    type: "Blogs",
    tech: ["Blogs"]
  },
  {
    name: "CSS is like your girlfriend, no one understands.",
    description:
      "Early browsers presented a page as hypertext — plain text, images and links to other hypertext pages. There was no layout at all to speak of, merely paragraphs running across the page in a single column, aka ugly ....",
    link: "https://thegoldenblogger.medium.com/css-is-like-your-girlfriend-no-one-understands-7e26ee88a204",
    type: "Blogs",
    tech: ["Blogs"]
  },
  {
    name: "E-sports A dream for millions of Indians.",
    description:
      "We all have seen and heard stories of e-sports legends , gamers going on stages lifting huge trophies, earning millions of dollars , fans cheering from all over the world , getting sponsors and what not .but…",
    link: "https://thegoldenblogger.medium.com/e-sports-a-dream-of-millions-of-indians-345265a3cb31",
    type: "Blogs",
    tech: ["Blogs"]
  }
];

export const QuickLinks = [
  { name: "github", value: "https://github.com/AhmerAftabPatel" },
  { name: "linkedin", value: "https://www.linkedin.com/in/ahmeraftab/" },
  { name: "google", value: "mailto:ahmerpatel123@gmail.com" },
  { name: "phone", value: "tel:8106938402" },
  { name: "facebook", value: "https://www.facebook.com/ahmer.aftab.3569/" }
];

export const whyHire =
  "My experience with technology and, in particular, my ability to maintain and update websites, make me a good match for any Frontend role. In my most recent role, I was responsible for maintaining the company's sales website. This required me to update, enhance, and maintain  clear code with utmost efficiency. I have also worked for a school, where I was given a task to develop an application which could track the daily activities of teachers , students and deans, I learnt the importance of good and proper education. There should be no compromise when it comes to education and providing knowledge. As mentioned in the job requirements ,I have experience in building a full fledged application with technologies like Nodejs, ReactJs, AngularJs, Express, Ruby On Rails and Django with Mongo and MySQL. I have a real time knowledge of production bugs and exceptions ,fixing production bugs takes more time than development it self and I am confident that I can counter any obstacle throwed at me .Finally, I simply love what I do. I love making an impact, spreading the word, and seeing the change for the world. I’m dedicated and passionate, and I guarantee that you won’t regret working with me. Thanks so much for giving your precious time to read.";
export const aFunAnswer =
  "I cant say I am a man of many talents which you will be WOW'ed with ,I have few interesting thing to do in my everyday life , and coding is one of those . I am atleast proud to say that I am good at what I do .I work for an NGO which is my uncle's we deliver food and scholarships to needy people I insisted to work for the foundation as a tech engineer , which made me realize that I can bring a change to this world , even if its the smallest of change .also am a karate champion ,with a ton of medals obviously gold one's  .Yes , I can be scary for a nerd.";
export const icanBeData =
  "I would like to introduce myself as a data Analyst too. As a detail-oriented and meticulous mathematician, I am confident in my ability to perform highly dense and algorithemetic data analysis. During my previous role at an internship, I worked with large amounts of data, facts, and figures. I am an expert at seeing through data to conclusions and crunching numbers. I often relied on my pristine communication skills to present my findings. I was responsible for translating my data into an understandable format for others to read. I am vigilant in ensuring that my data and findings are precise, and I can handle large volumes of data and mathematical problems with ease. During my academic career I studied a wide range of topics to support my statistical knowledge. My college education gave me access to topics such as probability, data computing, stochastic processes, game theory, machine learning etc . I look forward to more upcomming adventures. ";
